import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';

export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-summarydetail-popup',
  templateUrl: './summarydetail-popup.component.html',
  providers: [Modal],
  styleUrls: ['./summarydetail-popup.component.css']
})
export class SummarydetailPopupComponent implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  constructor(public dialog: DialogRef<CustomModalContext>, private modal: Modal, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.context = dialog.context;
  }

  ngOnInit() {}

  closeClick() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/_modalpopup/summarydetail-popup/summarydetail-popup.component.ts